import * as yup from 'yup';
import { TFunction } from 'i18next';

export const KEY_MAX_LENGTH = 25;
export const KEY_MIN_LENGTH = 3;
export const LABEL_MIN_LENGTH = 2;
export const LABEL_MAX_LENGTH = 30;
export const URL_MAX_LENGTH = 50;

const AddModuleValidationSchema = (t: TFunction) =>
  yup.object({
    url: yup
      .string()
      .matches(
        /((https):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
        t('validation:url_invalid') || undefined
      )
      .max(
        URL_MAX_LENGTH,
        t('validation:max_length', {
          name: t('url'),
          max: URL_MAX_LENGTH
        }) || undefined
      )
      .required(
        t('validation:is_required', {
          name: t('url')
        }) || undefined
      ),
    picture: yup
      .string()
      .required(t('validation:is_required', { name: t('module_picture') })),

    label: yup
      .object()
      .shape({
        de: yup
          .string()
          .min(
            LABEL_MIN_LENGTH,
            t('validation:min_length', {
              name: t('label_de'),
              min: LABEL_MIN_LENGTH
            }) || undefined
          )
          .max(
            LABEL_MAX_LENGTH,
            t('validation:max_length', {
              name: t('label_de'),
              max: LABEL_MAX_LENGTH
            }) || undefined
          )
          .required(
            t('validation:is_required', { name: t('label_de') }) || undefined
          ),
        en: yup
          .string()
          .min(
            LABEL_MIN_LENGTH,
            t('validation:min_length', {
              name: t('label_en'),
              min: LABEL_MIN_LENGTH
            }) || undefined
          )
          .max(
            LABEL_MAX_LENGTH,
            t('validation:max_length', {
              name: t('label_en'),
              max: LABEL_MAX_LENGTH
            }) || undefined
          )
          .required(
            t('validation:is_required', { name: t('label_en') }) || undefined
          )
      })
      .required()
  });

export type AddModuleSchemaData = yup.InferType<
  ReturnType<typeof AddModuleValidationSchema>
>;

export default AddModuleValidationSchema;
